export default "__VITE_PUBLIC_ASSET__3fbb94ad__"